import { render } from "./idCardExample.vue?vue&type=template&id=2277fb96"
import script from "./idCardExample.vue?vue&type=script&lang=js"
export * from "./idCardExample.vue?vue&type=script&lang=js"

import "./idCardExample.vue?vue&type=style&index=0&id=2277fb96&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__